export const numberWithSeparator = (numStr) => {
	return ('' + numStr).split(/(?=(?:\d{3})+(?:\.|$))/g).join(".")
}